(function() {
    'use strict';

    var AggiuntaDispositivoCtrl = function(
        $q,
        $scope,
        $state,
        $stateParams,
        $cacheFactory,
        CONSTANTS,
        messaggiFctr,
        aggiuntaDispositivoService,
        gestioneUtenteService,
        $uibModalInstance
    ) {
        this.loading = 0;
        this.gestioneUtenteService = gestioneUtenteService;
        this.nuovaCredenziale = {
            idCredenziale: null,
            nome: null,
            primoOtp: null,
            secondoOtp: null
        };
        this.erroriNuovoDispositivo = null;

        this.conferma = () => {
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            this.erroriNuovoDispositivo = null;

            let primoOtp = this.nuovaCredenziale.primoOtp;
            if (primoOtp) {
                primoOtp = primoOtp.toString().padStart(6, '0');
            }

            let secondoOtp = this.nuovaCredenziale.secondoOtp;
            if (secondoOtp) {
                secondoOtp = secondoOtp.toString().padStart(6, '0');
            }

            aggiuntaDispositivoService
                .aggiungi(gestioneUtenteService.datiMito.codiceUtente, gestioneUtenteService.datiMito.idUtente, this.nuovaCredenziale.idCredenziale, this.nuovaCredenziale.nome, primoOtp, secondoOtp)
                .then(
                    (resp) => {
                        if (messaggiFctr.processaResponse(resp)) {
                            return;
                        }
                        this.loading = (this.loading > 0) ? this.loading + 1 : 1;
                        aggiuntaDispositivoService
                            .disabilita(gestioneUtenteService.datiMito.codiceUtente, this.nuovaCredenziale.idCredenziale.replace(/\s/g, ''))
                            .then(
                                (result) => {
                                    if (messaggiFctr.processaResponse(result)) {
                                        return;
                                    }
                                    $uibModalInstance.close({
                                        idCredenziale: this.nuovaCredenziale.idCredenziale.replace(/\s/g, ''),
                                        nome: this.nuovaCredenziale.nome.trim(),
                                        statoAbilitato: 'ENABLED',
                                        pushAbilitato: false
                                    });
                                },
                                (error) => messaggiFctr.processaResponse(error)
                            )
                            .finally(() => this.loading--);
                    },
                    (reason) => {
                        messaggiFctr.processaResponse(reason);
                        if (!caricaMessaggiServizio(this, reason.data.errors)) {
                            if (!caricaMessaggiServizio(this, reason.data.warnings)) {
                                this.erroriNuovoDispositivo = { livello: '', messaggio: 'Si &egrave; verificato un errore imprevisto durante l\'aggiunta del dispositivo.', lista: null };
                            }
                        }
                        
                    }
                )
                .finally(() => this.loading--);
        };

        this.close = () => {
            $uibModalInstance.dismiss();
        };

        this.disabilitaConferma = () => {
            return !$scope.aggiuntaDispositivoForm.$valid;
        };

        this.getColoreErrore = () => {
            if (this.erroriNuovoDispositivo.livello == 'ERROR') {
                return 'red';
            }
            if (this.erroriNuovoDispositivo.livello == 'WARNING') {
                return 'orange';
            }
            return 'black';
        };

        function caricaMessaggiServizio(scope, serviceErrors) {
            if (serviceErrors && (serviceErrors.length > 0)) {
                scope.erroriNuovoDispositivo = { livello: serviceErrors[0].livello, messaggio: 'Si sono verificati degli errori durante l\'aggiunta del dispositivo:', lista: null };
                if (serviceErrors.length == 1) {
                    scope.erroriNuovoDispositivo.messaggio = serviceErrors[0].descrizione;
                } else {
                    scope.erroriNuovoDispositivo.lista = [];
                    serviceErrors.forEach(element => scope.erroriNuovoDispositivo.lista.push(element.descrizione));
                }
                return true;
            }
            return false;
        }
    };

    AggiuntaDispositivoCtrl.$inject = [
        '$q',
        '$scope',
        '$state',
        '$stateParams',
        '$cacheFactory',
        'Mitom_CONSTANTS',
        'MitomMessaggiFctr',
        'MitomAggiuntaDispositivoService',
        'MitomGestioneUtenteService',
        '$uibModalInstance'
    ];

    angular
        .module('cbl.mitomanager.wa')
        .controller('MitomAggiuntaDispositivoController', AggiuntaDispositivoCtrl);
})();